import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		button: {
			borderRadius: 20,
			"&:hover": {
				backgroundColor: "#DCDCDC",
			},
		},
		buttonOnHeader: {
			display: "flex",
			top: 5,
			borderRadius: 20,
			color: "#DCDCDC",
			"&:hover": {
				backgroundColor: "rgba(220, 220, 220, 0.2)",
			}
		}
	} satisfies Record<string, CSSObject>);
};
